import initialState from './initialState'
import * as types from '../actions/actionTypes'

export default function subscriptionRequests(state = initialState.requests, action: any) {
  switch (action.type) {
    case types.LOAD_SUBSCRIPTIONREQUESTS_SUCCESS:
      return action.requests;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/reducers/subscriptionRequestReducer.tsx